import { Client } from 'contensis-management-api';
import { ClientCredentials } from '@/types/ClientCredentials.types';
import ContensisUris from './ContensisUris';

const getManagementApiClient = (
  credentials: { username: string; password: string } | ClientCredentials
) => {
  const rootUrl = ContensisUris.api;
  const projectId = window.ContensisProjectApiId;

  const nullClient = Client.create({
    projectId,
    rootUrl,
  });

  if (!credentials) return nullClient;

  if ('username' in credentials) {
    return Client.create({
      clientType: 'contensis_classic',
      clientDetails: {
        username: credentials.username,
        password: credentials.password,
      },
      projectId,
      rootUrl,
    });
  } else if (typeof credentials.refreshToken === 'string') {
    const client = Client.create({
      clientType: 'contensis_classic_refresh_token',
      clientDetails: {
        refreshToken: credentials.refreshToken,
      },
      projectId,
      rootUrl,
    });
    if (credentials.bearerToken) client.bearerToken = credentials.bearerToken;
    if (credentials.bearerTokenExpiryDate)
      client.bearerTokenExpiryDate = new Date(
        credentials.bearerTokenExpiryDate
      );
    if (credentials.refreshToken)
      client.refreshToken = credentials.refreshToken;
    if (credentials.refreshTokenExpiryDate)
      client.refreshTokenExpiryDate = new Date(
        credentials.refreshTokenExpiryDate
      );
    if (credentials.contensisClassicToken)
      // Reassigning private class member is not allowed in TypeScript
      (client as any).contensisClassicToken = credentials.contensisClassicToken;
    return client;
  } else {
    return nullClient;
  }
};

export default getManagementApiClient;
